<template>
  <el-dialog
    :title="title"
    :visible.sync="visible"
    width="840px"
    append-to-body
    :close-on-press-escape="false"
    :close-on-click-modal="false"
    @closed="handleClosed">
    <el-form
      ref="ruleForm"
      :validate-on-rule-change="false"
      :model="ruleForm"
      :rules="rules"
      label-width="100px">
      <el-form-item
        label="产品名称："
        prop="goodsName">
        <el-input
          v-model="ruleForm.goodsName"
          show-word-limit
          :maxlength="32"></el-input>
      </el-form-item>
      <el-form-item
        v-if="visible"
        label="所属企业："
        prop="vendorId">
        <ent-remote-select
          ref="entRemoteSelect"
          v-model="ruleForm.vendorId"
          :clearable="false"
          @change="handleEntChange" />
      </el-form-item>
      <el-form-item
        label="质量证书："
        prop="certIds">
        <product-certificate-select
          v-if="ruleForm.vendorId"
          ref="cert"
          v-model="ruleForm.certIds"
          :options="{ vendorId: ruleForm.vendorId }" />
        <span v-else>请先选择所属企业</span>
      </el-form-item>
      <el-form-item
        label="排序值："
        prop="sortNumber">
        <el-input-number
          v-model="ruleForm.sortNumber"
          :precision="0"
          :min="1"
          :max="100"></el-input-number>
      </el-form-item>
      <el-form-item
        label="产品首图："
        prop="goodsSmallImage">
        <upload-with-crop
          v-model="ruleForm.goodsSmallImage"
          :cropper="true"
          :isLt2M="500"
          :limit="1"
          :fixedNumber="[1,1]"
          :autoCropWidth="120"
          :autoCropHeight="120"></upload-with-crop>
      </el-form-item>
      <el-form-item
        label="产品品牌："
        prop="brandName">
        <el-input
          v-model="ruleForm.brandName"
          show-word-limit
          :maxlength="24"></el-input>
      </el-form-item>
      <el-form-item
        label="产品产地："
        prop="originregion">
        <el-input
          v-model="ruleForm.originregion"
          show-word-limit
          :maxlength="12"></el-input>
      </el-form-item>
      <el-form-item
        label="净含量："
        prop="netContent">
        <el-input
          v-model="ruleForm.netContent"
          show-word-limit
          :maxlength="12"></el-input>
      </el-form-item>
      <el-form-item
        label="保质期："
        prop="shelflife">
        <el-input
          v-model="ruleForm.shelflife"
          show-word-limit
          :maxlength="12"></el-input>
      </el-form-item>
      <el-form-item
        label="自定义属性："
        prop="attributes">
        <el-table
          border
          :data="ruleForm.attributes">
          <el-table-column
            label="属性名"
            min-width="80">
            <template slot-scope="{ row }">
              <el-input
                v-model="row.name"
                show-word-limit
                :maxlength="12"></el-input>
            </template>
          </el-table-column>
          <el-table-column
            label="属性值"
            min-width="160">
            <template slot-scope="{ row }">
              <el-input
                v-model="row.value"
                show-word-limit
                :maxlength="24"></el-input>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            width="60">
            <template slot-scope="{ $index }">
              <el-button
                type="text"
                @click="deleteAttribute($index)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-button
          type="text"
          @click="addAttribute">添加属性</el-button>
      </el-form-item>
      <el-form-item
        label="产品介绍："
        prop="goodsDetailsImage">
        <desc-images
          v-model="ruleForm.goodsDetailsImage"
          edit></desc-images>
      </el-form-item>
      <el-form-item
        label="是否上架："
        prop="status">
        <el-switch
          v-model="ruleForm.status"
          :active-value="1"
          :inactive-value="2">
        </el-switch>
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button
        :loading="loading"
        @click="visible = false">取 消</el-button>
      <el-button
        type="primary"
        :loading="loading"
        @click="handleSubmit">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
import EntRemoteSelect from '@/components/ent-remote-select.vue'
import DescImages from '../../../components/public/desc-images.vue'
import UploadWithCrop from '../../../components/public/upload-with-crop.vue'
import Goods from '@/service/goods'
import { rules } from './utils'
import ProductCertificateSelect from './product-certificate-select.vue'
export default {
  name: 'EditGoodsModal',
  components: { DescImages, UploadWithCrop, EntRemoteSelect, ProductCertificateSelect },
  data() {
    return {
      loading: false,
      visible: false,
      ruleForm: {
        exchangeGoodsId: null,
        vendorId: null,
        vendorName: '',
        goodsName: '',
        sortNumber: 1,
        goodsSmallImage: [],
        goodsDetailsImage: [],
        certIds: [],
        brandName: '',
        originregion: '',
        netContent: '',
        shelflife: '',
        attributes: [],
        status: 1
      },
      rules
    }
  },
  computed: {
    title({ ruleForm }) {
      return (ruleForm.exchangeGoodsId ? '编辑' : '新增') + '合作产品'
    }
  },
  methods: {
    handleEntChange() {
      this.ruleForm.certIds = []
      setTimeout(() => {
        this.$refs.cert.fetchList()
      }, 100)
    },
    addAttribute() {
      this.ruleForm.attributes.push({ name: '', value: '' })
    },
    deleteAttribute(index) {
      this.ruleForm.attributes.splice(index, 1)
    },
    handleClosed() {
      this.ruleForm = { ...this.ruleForm, ...this.$options.data().ruleForm }
    },
    handleSubmit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.loading = true
          const { goodsSmallImage, goodsDetailsImage, exchangeGoodsId, attributes } = this.ruleForm
          if (attributes.length > 0 && attributes.some(i => !i.name || !i.value)) {
            this.$message.error('自定义属性不能为空')
            return
          }
          const dispatch = exchangeGoodsId ? 'updategoods' : 'addgoods'
          Goods[dispatch]({
            ...this.ruleForm,
            goodsSmallImage: this.$stringfyImage(goodsSmallImage),
            goodsDetailsImage: this.$stringfyImage(goodsDetailsImage)
          })
            .then(res => {
              this.loading = false
              const { result, message } = res.data
              if (result === 0) {
                this.visible = false
                this.$message.success('提交成功')
                this.$emit('fetch')
              } else {
                this.$message.error(message)
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error(err.message)
            })
        }
      })
    },
    init(options = {}) {
      const { goodsSmallImage, goodsDetailsImage, vendorId, vendorName } = options
      this.ruleForm = {
        ...this.ruleForm,
        ...options,
        goodsSmallImage: this.$splitImage(goodsSmallImage),
        goodsDetailsImage: this.$splitImage(goodsDetailsImage)
      }
      this.visible = true
      if (vendorName) {
        setTimeout(() => {
          this.$refs.entRemoteSelect.setInitValue([{ vendorId, vendorName }])
          this.$refs.cert.fetchList()
        }, 20)
      }
    }
  }
}
</script>
